@if (errorInfo$ | async; as errorInfo) {
  @if (errorInfo.hasFault || alwaysShow) {
    <div class="btn-group" role="group" [@navbarButtonAnimation]>
      <button
        class="btn btn-danger d-flex align-items-center"
        type="button"
        (click)="onResetFault()"
        [disabled]="resetting$ | async"
        [ngbTooltip]="errorInfo | deviceErrorInfoTitle"
        placement="bottom"
      >
        <i class="bi-exclamation-triangle-fill d-xxl-none"></i>
        <span class="d-none d-xxl-inline text-nowrap">RESET FAULT</span>
      </button>
      <button
        (click)="onOpenDeviceErrorInfoModal()"
        type="button"
        class="btn btn-danger info d-flex align-items-center"
        title="Show explanation and remedy"
      >
        <i class="bi-info-circle-fill"></i>
      </button>
    </div>
  }
}
